import { checkCapability } from "@/modules/users/utils/user.ts";
import { CAPABILITY } from "@/settings/settings.js";

import { type Capability, type Project } from "../graphql.js";
import { getProjectLabel } from "../redux/modules/config.js";

export function prjPrivateSavingAllowed(project: Project): boolean {
  // private saving is always allowed (actually it's mandatory) in private workspace
  return project.isPrivateWorkspace || project.capabilities?.[CAPABILITY.PRIVATE_SAVING].enabled;
}

export function prjCommentingAllowed(project: Project): boolean {
  return project.capabilities?.[CAPABILITY.PROJECT_COMMENTS].enabled;
}

export function canDownloadLogs(capabilities: Capability[]): boolean {
  return checkCapability(capabilities, CAPABILITY.VIEW_PLAYBOOK_EXECUTION_LOGS);
}

export function canSeeAdminActivities(capabilities: Capability[]): boolean {
  return checkCapability(capabilities, CAPABILITY.PROCESSOR_ADMIN_ACTIVITY);
}

export function getDisabledPrjCapabilityTooltipMessage(capability: number): string | null {
  if (capability === CAPABILITY.PRIVATE_SAVING) {
    return `Private saving is disabled for this ${getProjectLabel(false, false)}`;
  } else {
    return null;
  }
}
